import { useCallback, useRef } from 'react';
import { useForceUpdate } from './use-force-update';
/**
 * 每次render都会执行
 */
export function usePropsValue(_a) {
    var value = _a.value, defaultValue = _a.defaultValue, finalValue = _a.finalValue, _b = _a.onChange, onChange = _b === void 0 ? function (value) {
        //
    } : _b;
    console.log('usePropsValue--->');
    var forceUpdate = useForceUpdate();
    var dfValue = (defaultValue !== undefined ? defaultValue : finalValue);
    var stateRef = useRef(value !== undefined ? value : dfValue);
    if (value !== undefined) {
        stateRef.current = value;
    }
    var setState = useCallback(function (v, forceTrigger) {
        if (forceTrigger === void 0) { forceTrigger = false; }
        var prevState = stateRef.current;
        stateRef.current = v;
        if (prevState !== stateRef.current || forceTrigger) {
            forceUpdate();
            onChange === null || onChange === void 0 ? void 0 : onChange(v);
        }
    }, [value, onChange]);
    return [stateRef.current, setState];
}
